/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-08-22 10:49:45
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\register\locales\zh-CN.ts
 */
export default {
  'page.user.register.form-item-username': '请输入注册帐号邮箱',
  'page.user.register.form-item-username.required': '输入正确的邮箱帐号',
  'page.user.register.form-item-password': '请输入注册密码(6-20位)',
  'page.user.register.form-item-password.required': '请输入密码',
  'page.user.register.form-item-confirmpassword': '确认密码',
  'page.user.register.form-item-confirmpassword.compare': '您输入的两个密码不匹配！',
  'page.user.register.form.title': '注册账号',
  'page.user.register.form.btn-submit': '注册',
  'page.user.register.form.btn-jump': '已有账号？现在登录！',
  'page.user.register.form.register-success': '注册成功，请登录！',
  'page.user.register.form.agreement.start': '我已阅读并同意',
  'page.user.register.form.agreement.agre': '《用户协议》',
  'page.user.register.form.agreement.desc': '《用户隐私说明》'
};
